<div class="container">
    <div *ngIf="isLoading" class="overlay">
        <div class="spinner-border text-primary m-2" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="row d-flex justify-content-center mr-1 ml-1 pt-3">
            <div class="card d-flex p-0 col-sm-12 col-md-7" style="min-width: 400px">
                <div class="card-body border border-primary justify-content-center">
                    <img [src]="logoUrl" alt="" class="w-100"/>
                    <quill-view [content]="welcomeText" style="margin-top:10px; margin-bottom:10px"></quill-view>
                    <form [formGroup]="loginForm" (ngSubmit)="login()">
                        <div class="form-group">
                            <label for="username">Username<span class="text-danger font-weight-bolder h3"> *</span></label>
                            <input class="form-control mb-2" type="text" id="username" formControlName="username" required />
                            <label for="password">Password<span class="text-danger font-weight-bolder h3"> *</span></label>
                            <input class="form-control mb-2" type="password" id="password" formControlName="password" required />
                            <span *ngIf="capsLockOn" class="badge rounded-pill bg-warning text-white mt-1">Caps lock on</span>
                            <button class="btn btn-primary mt-3 w-100" [disabled]="loginForm.invalid">Sign In</button>
                        </div>
                    </form>
                </div>
            </div>
    </div>
</div>
<app-login-footer></app-login-footer>
